import TransferenciaEntrada from "./TransferenciaEntrada";
export default TransferenciaEntrada;